var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { withRouter } from 'react-router';
import Header from './partials/Header';
import Footer from './partials/Footer';
import MobileNavigation from './partials/MobileNavigation';
import GlobalConfirm from '../modules/Confirm/GlobalConfirm';
import CookieConsent from '../components/CookieConsent';
import Divider from '../components/Divider';
import { createClassListFromModifiers } from '../core/utils/class-helper';
var DefaultLayout = /** @class */ (function (_super) {
    __extends(DefaultLayout, _super);
    function DefaultLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultLayout.prototype.render = function () {
        var classList = __spreadArray([
            'l-default'
        ], createClassListFromModifiers('l-default', this.props.modifiers));
        return (React.createElement("div", { className: classList.join(' ') },
            React.createElement(CookieConsent, null),
            !this.props.disableMobileNavigation && React.createElement(MobileNavigation, null),
            React.createElement("div", { className: "l-default__header" }, !this.props.disableHeader && (React.createElement(React.Fragment, null,
                React.createElement(Header, null),
                !this.props.disableHeaderDivider && React.createElement(Divider, null)))),
            React.createElement("main", { className: "l-default__content" }, this.props.children),
            !this.props.disableFooter && React.createElement(Footer, null),
            React.createElement(GlobalConfirm, null)));
    };
    return DefaultLayout;
}(React.Component));
export default withRouter(DefaultLayout);
